import { Injectable } from '@angular/core';
import { Converter, Occ } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { SikoOccUtils } from '@siko/shared/utils/siko-occ-utils';

@Injectable({ providedIn: 'root' })
export class SikoOccOrderNormalizer implements Converter<Occ.Order, Order> {

    constructor(private readonly occUtils: SikoOccUtils) {}

    convert(source: Occ.Order, target?: Order): Order {
        if (target === undefined) {
            target = { ...(source as any) } as Order;
        }

        if (source.pickupOrderGroups) {
            target.pickupOrderGroups = source.pickupOrderGroups.map((pickupOrderGroup: Occ.PickupOrderEntryGroup) => {
                return this.occUtils.convertOrderGroup(pickupOrderGroup, source.code);
            });
        }

        if (source.deliveryOrderGroups) {
            target.deliveryOrderGroups = source.deliveryOrderGroups.map((deliveryOrderGroup: Occ.DeliveryOrderEntryGroup) => {
                return this.occUtils.convertOrderGroup(deliveryOrderGroup, source.code);
            });
        }

        return target;
    }

}
